import { render } from "./perfectQuotes.vue?vue&type=template&id=59343a51&scoped=true"
import script from "./perfectQuotes.vue?vue&type=script&lang=js"
export * from "./perfectQuotes.vue?vue&type=script&lang=js"

import "./perfectQuotes.vue?vue&type=style&index=0&id=59343a51&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59343a51"]])

export default __exports__